var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 41,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.284.95H2.58A1.975 1.975 0 0 0 .605 2.927V34.53a1.975 1.975 0 0 0 1.975 1.975h1.976v1.975a1.975 1.975 0 1 0 3.95 0v-1.975h17.778a5.926 5.926 0 0 0 5.926-5.926V6.877A5.926 5.926 0 0 0 26.284.95Zm-5.926 31.606H4.556V4.9h15.802v27.655Zm7.901-1.976a1.975 1.975 0 0 1-1.975 1.976h-1.975V4.9h1.975a1.975 1.975 0 0 1 1.975 1.976V30.58Z",
    fill: "#2F42C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiaryIcon);
export default __webpack_public_path__ + "static/media/diary_icon.54f092b1c89c62ca49c386bedcadb8e3.svg";
export { ForwardRef as ReactComponent };